import { render, staticRenderFns } from "./norgesenergi.vue?vue&type=template&id=385d2d9c&scoped=true&"
var script = {}
import style0 from "./norgesenergi.vue?vue&type=style&index=0&id=385d2d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d2d9c",
  null
  
)

export default component.exports